import { Lock } from "@phosphor-icons/react";
import { t } from "@lingui/macro";

import { cn } from "@reactive-resume/utils";
import { Button, Tooltip } from "@reactive-resume/ui";
import { useBreakpoint } from "@reactive-resume/hooks";

import { useResumeStore } from "@/client/stores/resume";
import { useBuilderStore } from "@/client/stores/builder";
import { useSaveStatusStore } from "@/client/stores/useSaveStatusStore";

import { SaveStatusBadge } from "./SavingIndicator";

// Renders the Builder page header
export const BuilderHeader = () => {
  const { isDesktop } = useBreakpoint();

  const title = useResumeStore((state) => state.resume.title);
  const locked = useResumeStore((state) => state.resume.locked);

  const toggle = useBuilderStore((state) => state.toggle);
  const isDragging = useBuilderStore(
    (state) => state.panel.left.handle.isDragging || state.panel.right.handle.isDragging,
  );
  const leftPanelSize = useBuilderStore((state) => state.panel.left.size);
  const rightPanelSize = useBuilderStore((state) => state.panel.right.size);
  const sheet = useBuilderStore((state) => state.sheet);

  const status = useSaveStatusStore((s) => s.status);

  const onToggle = (side: "left" | "right") => {
    toggle(side);
  };

  return (
    <div
      style={{ left: `${leftPanelSize}%`, right: `${rightPanelSize}%` }}
      className={cn(
        "fixed inset-x-0 top-0 z-[60] h-[3rem] bg-neutral-100 backdrop-blur-lg lg:z-20",
        !isDragging && "transition-[left,right]",
      )}
    >
      <div className="flex h-full w-full items-center">
        {/* Home screen button and resume title */}
        <div className="mx-auto flex w-full items-center justify-between px-4">
          <div className="flex w-full items-center justify-center gap-x-2 lg:mx-auto">
            {/* Show full title for desktop and short title with ellipses for mobile view */}
            <h1 className="w-max font-medium">
              {!isDesktop && title.length > 35 ? title.slice(0, 35) + "..." : title}
            </h1>
            {locked && (
              <Tooltip content={t`This resume is locked, please unlock to make further changes.`}>
                <Lock size={14} className="ml-2 opacity-75" />
              </Tooltip>
            )}
          </div>

          {/* Saving/Saved Status Indicator */}
          <div className="mr-2 flex w-full items-center justify-end">
            <SaveStatusBadge status={status} />
          </div>
        </div>
      </div>
    </div>
  );
};
